import { BannerWrapper } from "../BannerWrapper";
import { SkeletonBlock } from "@zapier/design-system";

type ProgressBannerProps = {
  title?: string;
  description?: string;
};

export function ProgressBanner({
  title = "Building your system",
  description = "Generating the assets for your canvas",
}: ProgressBannerProps) {
  return (
    <BannerWrapper title={title} description={description} showProgress={true}>
      <SkeletonBlock color="GrayWarm3" width="91px" height="36px" />
      <SkeletonBlock color="GrayWarm3" width="152px" height="36px" />
      <SkeletonBlock color="GrayWarm3" width="133px" height="36px" />
    </BannerWrapper>
  );
}
